/* unplugin-vue-components disabled */import { render } from "./guardrails.vue?vue&type=template&id=317ea19d"
import script from "./guardrails.vue?vue&type=script&lang=js"
export * from "./guardrails.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/settings/superuser/guardrails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "317ea19d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('317ea19d', __exports__)) {
    api.reload('317ea19d', __exports__)
  }
  
  module.hot.accept("./guardrails.vue?vue&type=template&id=317ea19d", () => {
    api.rerender('317ea19d', render)
  })

}


export default __exports__